import NativeSelect from './native-select';
import NativeOption from './native-option';
import NativeOptGroup from './native-opt-group';
var DefaultSelect = NativeSelect;
DefaultSelect.Option = NativeOption;
DefaultSelect.OptGroup = NativeOptGroup;
export default DefaultSelect;
//# sourceMappingURL=index.js.map